import { TEXT_FIELD_MAX, clinicalReasonPayload } from '@/lib/referral/xref01Validation';

/**
 * XREF06 (speciallægehenvisning) ClinicalReason.
 *
 * MedCom XREF06.pdf (XH0631R, opdateret 20.05.2026), Facitliste p. 19:
 * `<ClinicalReason>Henvisningsaarsag_eller_oensket_undersoegelse</ClinicalReason>`,
 * FeltDef tx..350, no M (optional), under AdditionalInformation (no M).
 * PrivateSpecialistReferral.xsd 2021/06/27: ClinicalReason minOccurs="0".
 * Optional in the standard, so the form does not require it; when it is
 * filled in, it is sent.
 */
export const XREF06_CLINICAL_REASON_LABEL = 'Henvisningsårsag eller ønsket undersøgelse';

export const XREF06_CLINICAL_REASON_MAX = TEXT_FIELD_MAX;

/** `additionalInformation` for the XREF06 request, or null when left empty. */
export function xref06AdditionalInformation(value: string): { clinicalReason: string[] } | null {
  const lines = clinicalReasonPayload(value);
  return lines ? { clinicalReason: lines } : null;
}

export function xref06ClinicalReasonTooLong(value: string): boolean {
  return value.trim().length > XREF06_CLINICAL_REASON_MAX;
}
